import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup, Typography } from '_atoms';
import './styles.scss';

interface PopupApproveOpeningProps {
  open: boolean;
  onOk: () => void;
  onClose: () => void;
}

export const PopupApproveOpening: React.FC<PopupApproveOpeningProps> = ({ open, onOk, onClose }) => {
  const { t } = useTranslation();

  return (
    <Popup
      className="popup-approve-opening"
      open={open}
      title={t('translation:popup_approve_opening.title')}
      cancelButtonProps={{ onClick: onClose, children: t('translation:popup_approve_opening.cancel') }}
      okButtonProps={{ onClick: onOk, children: t('translation:popup_approve_opening.approve') }}
    >
      <Typography.Text className="popup-approve-opening__info-text">
        {t('translation:popup_approve_opening.info_text')}
      </Typography.Text>
    </Popup>
  );
};
